import SearchIcon from '@/assets/icons/search.svg?react';
import { Input } from '@/components/ui/input/input.component';
import { cn } from '@/lib/utils';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchInput = ({ className, placeholder, onSearch: handleSearch, ...props }: Props) => {
  return (
    <div className={cn('relative', className)}>
      <div className="absolute top-0 bottom-0 w-8 flex justify-center items-center">
        <SearchIcon />
      </div>
      <Input
        {...props}
        data-testid="search-bar-input"
        onChange={handleSearch}
        className="h-8 min-w-[324px] pl-9"
        placeholder={placeholder}
      />
    </div>
  );
};
